import apiClient from './apiClient';

/**
 * Doctor calendar blocks (Lunch / Training / Leave) — create, list (expanded
 * to per-day occurrences), delete the whole series, or skip just one day.
 */

function buildApiError(error) {
  const msg = error?.response?.data?.detail || error?.message || 'Unknown error';
  const err = new Error(msg);
  err.status = error?.response?.status;
  return err;
}

const base = (doctorId) => `/api/organisation/doctors/${doctorId}/blocks`;

/** POST /doctors/{id}/blocks — create a block rule. */
export const createDoctorBlock = async (doctorId, payload) => {
  try {
    const r = await apiClient.post(base(doctorId), payload);
    return r.data;
  } catch (e) { console.error('[BlockAPI] create', e); throw buildApiError(e); }
};

/** GET /doctors/{id}/blocks?date_from=&date_to= — expanded occurrences. */
export const listDoctorBlocks = async (doctorId, dateFrom, dateTo) => {
  try {
    const params = { date_from: dateFrom };
    if (dateTo) params.date_to = dateTo;
    const r = await apiClient.get(base(doctorId), { params });
    return r.data;
  } catch (e) { console.error('[BlockAPI] list', e); throw buildApiError(e); }
};

/** DELETE /doctors/{id}/blocks/{blockId} — delete the whole series. */
export const deleteDoctorBlock = async (doctorId, blockId) => {
  try {
    const r = await apiClient.delete(`${base(doctorId)}/${blockId}`);
    return r.data;
  } catch (e) { console.error('[BlockAPI] delete', e); throw buildApiError(e); }
};

/** DELETE /doctors/{id}/blocks/{blockId}/occurrence?date= — skip just one day. */
export const skipDoctorBlockOccurrence = async (doctorId, blockId, date) => {
  try {
    const r = await apiClient.delete(`${base(doctorId)}/${blockId}/occurrence`, { params: { date } });
    return r.data;
  } catch (e) { console.error('[BlockAPI] skip', e); throw buildApiError(e); }
};
